import React, { useState } from "react";
import { Swiper, SwiperSlide } from "swiper/react";
import { CatechesisCard, SectionHeading } from "../components";
import { Skeleton } from "../components/ui/skeleton";

// Import Swiper styles
import "swiper/css";
import "swiper/css/free-mode";
import "swiper/css/pagination";

// import required modules
import { Pagination, Autoplay } from "swiper/modules";

const CatechesisSlider = ({
  data = {},
  isLoading,
  onToggleFavorite,
}) => {
  const { title, icon, link, linkTitle, items , titleClass="" } = data;

  // const items = Array.isArray(data?.items) ? data.items : [];

  return (
    <div className="py-8">
      {/* <SectionHeading
        title={heading.title}
        icon={heading.icon}
        link={heading.link}
        linkTitle={heading.linkTitle}
        classes='mb-4'
      /> */}
      {/* Section Heading */}
      { title && isLoading ? (
        <div className="flex items-center justify-between mb-4">
          <div className="flex items-center gap-2">
            <Skeleton className="h-8 w-6 rounded" />
            <Skeleton className="h-8 w-32 rounded" />
          </div>
          <Skeleton className="h-5 w-20 rounded" />
        </div>
      ) : (
        title && (
          <SectionHeading
            title={title}
            icon={icon}
            link={link}
            linkTitle={linkTitle}
            titleClass={titleClass}
            classes='mb-4'
          />
        )
      )}
      {/* {title && isLoading ? (
        <div className="flex items-center justify-between mb-4">
          <div className="flex items-center gap-2">
            <Skeleton className="h-8 w-6 rounded" />
            <Skeleton className="h-8 w-32 rounded" />
          </div>
          <Skeleton className="h-5 w-20 rounded" />
        </div>
      ) : (
        title && (
          <SectionHeading
            title={title}
            icon={icon}
            link={link}
            linkTitle={linkTitle}
          />
        )
      )} */}

      {isLoading ? (
        <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-3 gap-4">
          {Array.from({ length: 3 }).map((_, index) => (
            <div key={index} className=" rounded-lg shadow-md">
              <Skeleton className="h-[248px] w-full rounded-md" />
            </div>
          ))}
        </div>
      ) : (
        <Swiper
          slidesPerView={1}
          slidesPerGroup={1}
          spaceBetween={16}
          pagination={{
            clickable: true,
          }}
          autoplay={{
            delay: 3000,
            disableOnInteraction: false,
            pauseOnMouseEnter: true,
          }}
          breakpoints={{
            0: {
              slidesPerView: 1,
            },
            768: {
              slidesPerView: 2,
            },
            1281: {
              slidesPerView: 3,
            },
          }}
          modules={[Pagination, Autoplay]}
          className="culture-card-slider"
        >
          {items.map((item, index) => (
            <SwiperSlide key={index}>
              <CatechesisCard
                key={index}
                {...item}
                title={item.title}
                favorite={item.favorite}
                onToggleFavorite={onToggleFavorite}
              />
            </SwiperSlide>
          ))}
        </Swiper>
      )}
    </div>
  );
};

export default CatechesisSlider;
